import React, { useContext, useEffect, useState } from "react";
import { MainLanguageContext } from "../context/MainLanguageContext";
import { Modal, Pagination, Space, Table } from "antd";
import useGet from "../customHooks/useGet";
import { Link } from "react-router-dom";

const ActivitiesLogs = () => {
  const { mainLanguage } = useContext(MainLanguageContext);
  const [resget, apiMethodGet] = useGet();
  const [datas, setDatas] = useState();
  const [openRowData, setOpenRowData] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const emptyFilters = {
    search: '', changes_key: '', changes_value: '', user_id: '', user_name: '', user_email: '',
    action: '', action_in: '', model_type: '', table_name: '', table_name_in: '', date_from: '', date_to: '',
  };
  const [filters, setFilters] = useState(emptyFilters);
  const [activeFilters, setActiveFilters] = useState(emptyFilters);

  const loadLogs = (page = 1, perPage = pageSize, selectedFilters = activeFilters) => {
    if (!mainLanguage) return;
    setCurrentPage(page);
    const params = new URLSearchParams({ per_page: String(perPage), page: String(page) });
    Object.entries(selectedFilters).forEach(([key, value]) => {
      if (value.trim()) params.set(key, value.trim());
    });
    apiMethodGet(`activities/adminSideAllLogs/0?${params.toString()}`);
  };

  useEffect(() => {
    loadLogs(1, pageSize, activeFilters);
  }, [mainLanguage]);

  const onChange = (current) => loadLogs(current);

  const handleFilterSubmit = (event) => {
    event.preventDefault();
    setActiveFilters(filters);
    loadLogs(1, pageSize, filters);
  };

  const handlePageSizeChange = (event) => {
    const nextPageSize = Number(event.target.value);
    setPageSize(nextPageSize);
    loadLogs(1, nextPageSize);
  };

  const clearFilters = () => {
    setFilters(emptyFilters);
    setActiveFilters(emptyFilters);
    loadLogs(1, pageSize, emptyFilters);
  };

  useEffect(() => {
    if (resget.data) {
      const updatedData = resget?.data?.data?.map((item, index) => ({
        ...item,
        key: `item-${index}`, // Add a unique key to each object
      }));
      setDatas(updatedData);
    }
  }, [resget.data]);


    const showModal = (item) => {
    setOpenRowData(item)
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  
const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "User",
   render: (_, record) => (
              <>
              <div>{record?.user_name}</div>
              <div>{record?.user_email}</div>
              </>
            ),
  },
  // {
  //   title: "Changes",
  //   render: (_, record) => (
  //             <>
  //              {/* <div>
  //       {JSON.stringify(record?.changes, null, 2)}
  //     </div> */}
  //             </>
  //           ),
  // },
  {
    title: "Identity",
    dataIndex: "row_identity", // example field
    key: "row_identity",
  },
  {
    title: "Table Name",
    dataIndex: "table_name", // example field
    key: "table_name",
  },
  {
    title: "Updated",
    dataIndex: "action", // example field
    key: "action",
  },
  {
    title: "Date",
    dataIndex: "created_at", // example field
    key: "created_at",
  },
   {
      key: 'action',
      title: 'Action',
fixed: 'right',
      render: (_, record) => (
        <Space size="middle">
         <div className='flex items-center gap-3 tableaction'>
         <Link key={`view-${record.id}`} onClick={() => showModal(record)}>
          <img src={require("../dist/webImages/view.png")} alt="" />
        </Link>
         </div>
        </Space>
      ),
    },
];
  
  return (
    <div className="pr-10">
      <h2 className="font-Mluvka text-[1.938rem] max-lg:text-[1.1rem] mb-2">
        Activities Logs
      </h2>
      <form onSubmit={handleFilterSubmit} className="mb-4 rounded-2xl border border-[#E6ECF5] bg-white p-4">
        <div className="grid grid-cols-4 gap-3 max-xl:grid-cols-3 max-lg:grid-cols-2 max-md:grid-cols-1">
          {[
            ['search', 'Search', 'Search log details'],
            ['changes_key', 'Changed field', 'e.g. monthly_price'],
            ['changes_value', 'Changed value', 'e.g. 2499'],
            ['user_id', 'User ID', 'e.g. 12'],
            ['user_name', 'User name', 'e.g. Alex'],
            ['user_email', 'User email', 'admin@example.com'],
            ['action', 'Action', 'e.g. updated'],
            ['action_in', 'Actions (multiple)', 'created,updated,deleted'],
            ['model_type', 'Model type', 'e.g. App\\Models\\Product'],
            ['table_name', 'Table name', 'e.g. products'],
            ['table_name_in', 'Table names (multiple)', 'products,blogs'],
            ['date_from', 'Date from', ''],
            ['date_to', 'Date to', ''],
          ].map(([name, label, placeholder]) => (
            <label key={name} className="text-sm font-medium text-[#52627A]">{label}
              <input
                type={name === 'date_from' || name === 'date_to' ? 'date' : name === 'user_id' ? 'number' : 'text'}
                name={name}
                value={filters[name]}
                onChange={(event) => setFilters((current) => ({ ...current, [name]: event.target.value }))}
                placeholder={placeholder}
                className="mt-2 h-11 w-full rounded-xl border border-[#DCE4F2] px-4 font-normal outline-none focus:border-primary focus:ring-4 focus:ring-primary/10"
              />
            </label>
          ))}
          <label className="text-sm font-medium text-[#52627A]">Rows per page
            <select value={pageSize} onChange={handlePageSizeChange} className="mt-2 h-11 w-full rounded-xl border border-[#DCE4F2] bg-white px-3 font-normal outline-none focus:border-primary">
              {[10, 20, 50, 100].map((size) => <option key={size} value={size}>{size}</option>)}
            </select>
          </label>
        </div>
        <div className="mt-4 flex gap-2">
          <button type="submit" className="h-11 rounded-full bg-primary px-6 text-sm font-semibold text-white transition hover:brightness-95">Search</button>
          <button type="button" onClick={clearFilters} className="h-11 rounded-full border border-[#DCE4F2] px-5 text-sm font-medium text-[#52627A] transition hover:bg-[#F6F8FC]">Clear</button>
        </div>
      </form>
      <div className="relative">
        {resget.isLoading ? (
          ""
        ) : (
          <div>
            <div className="bookingPagepagination overflow-auto">
              <Table
                scroll={{ x: 1300 }}
                dataSource={datas}
                columns={columns}
              />
            </div>

            {(datas?.length !== 0 || !resget?.error) && (
              <div className="my-4">
                <Pagination
                  onChange={onChange}
                  current={currentPage}
                  total={resget.data?.pagination?.total}
                  pageSize={pageSize}
                  showSizeChanger={false}
                />
              </div>
            )}
          </div>
        )}
      </div>
       {openRowData &&   <Modal width={'70%'} title={openRowData?.user_name} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>

                    <div className='venderview'>
                <h2></h2>
                    <div className="grid grid-cols-3 gap-4">
                      <div className="venderview py-2 px-3 bg-[#ddd] rounded-md">
                        <label htmlFor=""><b>Id</b>: </label>
                        <span>{openRowData.id}</span>
                      </div>
                      <div className="venderview py-2 px-3 bg-[#ddd] rounded-md">
                        <label htmlFor=""><b>Email</b>: </label>
                        <span>{openRowData.user_email}</span>
                      </div>
                      <div className="venderview py-2 px-3 bg-[#ddd] rounded-md">
                        <label htmlFor=""><b>Identity</b>: </label>
                        <span>{openRowData.row_identity}</span>
                      </div>
                      <div className="venderview py-2 px-3 bg-[#ddd] rounded-md">
                        <label htmlFor=""><b>Table Name</b>: </label>
                        <span>{openRowData.table_name}</span>
                      </div>
                      <div className="venderview py-2 px-3 bg-[#ddd] rounded-md">
                        <label htmlFor=""><b>Updated</b>: </label>
                        <span>{openRowData.action}</span>
                      </div>
                      <div className="venderview py-2 px-3 bg-[#ddd] rounded-md">
                        <label htmlFor=""><b>Date</b>: </label>
                        <span>{openRowData.created_at}</span>
                      </div>
                    </div>
           <div className="venderview mt-4 py-2 px-3 bg-[#ddd] rounded-md">
                        <label htmlFor=""><b>Changes</b>: </label>
                        <span>{JSON.stringify(openRowData?.changes, null, 2)}</span>
                      </div>

                     
                    </div>
                   
                  

        </Modal>}
    </div>
  );
};

export default ActivitiesLogs;
